/**
 * MoveCounter - View component for displaying move count
 * Pure presentation component with no business logic
 */

import React from 'react';

export default function MoveCounter({ count }) {
  return (
    <div className="move-count" aria-live="polite">
      <div className="move-count-label">Moves</div>
      <div className="move-count-value">{count}</div>
    </div>
  );
}
